import React, { useState, useEffect } from "react";
import "./Balance.css";
import { fetchWalletTxns } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const WalletTransactionTable = () => {
  const token = useSelector(store => store.userReducer.token);
  const role = useSelector((store) => store.userReducer.role);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    const getWalletData = async () => {
      try {
        const response = await fetchWalletTxns(token);

        setTableData(response.data)
      } catch(err) {
        toast.error(err.message)
      }
    }

    getWalletData();
    setIsLoading(false);
  }, [])

  return (
    <div className="wallet-table-container">
      <h2 className="wallet-table-title">Wallet Transactions</h2>
      <table className="wallet-table">
        <thead>
          <tr>
            <th>Merchant Name</th>
            <th>Previous Balance</th>
            <th>Deposit Amount</th>
            <th>Wallet Balance</th>
            <th>Payment Mode</th>
            <th>UTR</th>
           {(role !== 'admin' && role !=='mops') && <th>Remarks</th>}
            <th>Wallet Loaded By</th>
            <th>Updated At</th>
          </tr>
        </thead>
        <tbody>
          {tableData?.map((transaction, index) => (
            <tr key={index}>
              <td>{transaction.User_FundLoad_userIdToUser?.alias || transaction.User_FundLoad_userIdToUser?.id}</td>
              <td>₹ {Number(transaction.previousBalance).toFixed(2)|| "0"}</td>
              <td>₹ {Number(transaction.depositAmount).toFixed(2)|| "0"}</td>
              <td>
                ₹ {Number(transaction.depositAmount + transaction.previousBalance).toFixed(2)|| "0"}
              </td>
              <td>{transaction.paymentMode}</td>
              <td>{transaction.utr || "-"}</td>
             {(role !== 'admin' && role !=='mops') &&  <td>{transaction.remark || "-"}</td>}
              <td>{transaction?.User_FundLoad_loadedByToUser?.name}</td>
              <td>{new Date(transaction?.updatedAt).toLocaleString('en-GB',{
                day:'2-digit',
                month:'2-digit',
                year:'numeric',
                hour:'2-digit',
                minute:'2-digit',
              hour12:false
              })}</td>
            </tr>
          ))}
        </tbody>

        {/* ////////////////////////// */}
      </table>
    </div>
  );
};

export default WalletTransactionTable;
